import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { BaseService } from './base.service';
import { environment } from 'src/environments/environment';
import { SoftSkillCategory, SoftSkill } from '../models/badges';
import { EventResponse,
  Event,
  EnrolledCourse,
  NotificationResponse,
  Notification,
  User,
  CompetencyResponse,
  CourseResponse,
  PagesResponse,
  LessonsResponse,
  ForumResponse,
  DiscussionResponse,
  DiscussionPost,
  PostResponse,
  Quiz,
  StartQuizAttemptResponse,
  MoodleConfiguration,
  Category,
  MoodleCategory,
  MoodleCourse ,
  ProcessQuizAttemptResponse,
  QuizAttemptDetailsResponse,
  MoodleUser,
  MoodleUserDetail,
  CompetenciesScale,
  GradeCompetency,
  CompetenciesGrades,
  UserCompetencyGrade,
  UserQuizAttemptResponse,
  UserRole,
  UserEnrolledCourse,
  CourseList,
  NewCourse,
  CompetenciesPassport
} from '../models/moodle';
import { AuthService } from './auth.service';
import { BehaviorSubject, firstValueFrom, Observable, ReplaySubject, take } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

declare var window : {
  M: MoodleConfiguration
}
@Injectable({
  providedIn: 'root'
})

export class MoodleWebService extends BaseService {
  auth = inject(AuthService);
  private bufferSize: number = 1; 

  private eventsCoursesQuery: string = "";
  private categoriesId: Array<number> = [];
  private eventsCategoryQuery: string = "";

  public allStudents$ = new ReplaySubject<Array<MoodleUser>>(this.bufferSize);
  public teacherDashboardData$ = new ReplaySubject<Array<MoodleUser>>(this.bufferSize);

  public allCourses$ = new ReplaySubject<Array<MoodleCourse>>(this.bufferSize);
  public allCourses: Signal<Array<MoodleCourse>> = toSignal(this.allCourses$, { initialValue: [] });
  public courseCategories$ = new ReplaySubject<Array<Category>>(this.bufferSize);
  public categories: Signal<Array<Category>> = toSignal(this.courseCategories$, { initialValue: [] });

  public enrolledCourses$ = new ReplaySubject<Array<EnrolledCourse>>(this.bufferSize);
  public allEnrolledCourses$ = new ReplaySubject<Array<EnrolledCourse>>(this.bufferSize);
  public progressCourses$ = new ReplaySubject<Array<EnrolledCourse>>(this.bufferSize);
  public userEvents$ = new ReplaySubject<Array<Event>>(this.bufferSize);
  public userNotifs$ = new ReplaySubject<Array<Notification>>(this.bufferSize);

  public forumContent$ = new ReplaySubject<Array<ForumResponse>>(this.bufferSize);
  public discussionsContent$ = new ReplaySubject<Array<DiscussionPost>>(this.bufferSize);
  public postsContent$ = new ReplaySubject<Array<PostResponse>>(this.bufferSize);

  public allQuiz$ = new ReplaySubject<Array<Quiz>>(this.bufferSize);
  public lastQuizzes$ = new ReplaySubject<Array<any>>(this.bufferSize);
  public gradeState$ = new ReplaySubject<boolean>(this.bufferSize);

  private referentiel$ = new ReplaySubject<Array<SoftSkillCategory>>(this.bufferSize);
  public referentiel: Signal<Array<SoftSkillCategory>> = toSignal(this.referentiel$, { initialValue: [] });

  private passport$ = new ReplaySubject<Array<CompetenciesPassport>>(this.bufferSize);
  public passport: Signal<Array<CompetenciesPassport>> = toSignal(this.passport$, { initialValue: [] });

  public userMoodleData: WritableSignal<any> = signal<any>([]);

  public referentielCategories: WritableSignal<Array<number>> = signal([]);
  
  private competenciesScale$ = new ReplaySubject<Array<CompetenciesScale>>(this.bufferSize);
  public competenciesScale: Signal<Array<CompetenciesScale>> = toSignal(this.competenciesScale$, { initialValue: [] });

  constructor() { 
    super(); 
    this.getCourseStudents(27);
    
    this.getSoftSkills()
      .catch((error) => console.error(error));

    this.getCompetenciesScale()
      .catch((error) => console.error(error));

    this.getAllQuizzes()  
      .then((res: Array<Quiz>) => {    
        this.getTeacherDashboard();            
        console.log(this.getAutoEvalQuiz());        
      })
      .catch((error) => console.error(error)); 

    this.getCourseCategories()
      .catch((error) => console.error(error)); 

    this.getAllCourses()  
      .catch((error) => console.error(error)); 

    this.auth.updateUserConnectionStatus().then(()=>{
      // Send only user infos
      if (this.auth.currentUser().isConnected) {
        // Send user infos, enrolledCourses, quiz and evaluation
        this.teacherDashboardData$.subscribe((res: any) => {          
          for (const user of res) {
            if (user.id === this.auth.currentUser().auth.id) this.userMoodleData.set(user);
          }
        })

        this.getCoursesWithTag("passeport_competences")
          .then((course: any) => {
            let coursesId: Array<any> = []
            course.map((data: any) => { coursesId.push(data.courseid) })
            this.enrolledCourses$.subscribe((courses: any) => {              
              courses.map((course: any) => {
                if (coursesId.includes(course.id)) {
                  this.getCoursePageContent(course.id)
                    .catch((error) => console.error(error));   
                }
              })              
            })
          })
          .catch((error) => console.error(error));          

        this.getUserEnrolledCourses()
          .catch((error) => console.error(error));

        this.getUserProgressedCourses()
          .catch((error) => console.error(error));
  
        this.getUserEvents()
          .catch((error) => console.error(error));     
             
        this.getUserNotifs()
          .catch((error) => console.error(error));  

        this.getAllCourses()
          // .then((courses: Array<MoodleCourse>) => {            
          //   if (courses) {
          //     const forumList: Array<ForumResponse> = [];
          //     const discussionList: Array<DiscussionPost> = [];   
          //     const postList: Array<PostResponse> = [];
          //     courses.map((course: MoodleCourse)=> {
          //       this.getCourseForums(course.id, forumList)
          //         .then((course: Array<ForumResponse>) => {
          //           course.map((forum: ForumResponse)=> {
          //             this.getForumDiscussions(forum.id, discussionList)
          //               .then((forum: DiscussionResponse) => {
          //                 forum.discussions.map((discussion: DiscussionPost)=> {                        
          //                   this.getDiscussionPosts(discussion, postList);
          //                 })
          //               })
          //               .catch((error) => console.error(error));    
          //           });
          //         })
          //         .catch((error) => console.error(error));    
          //     });                         
          //   }
          // })
          .catch((error) => console.error(error));  
      }
    })
  }

  getSoftSkills(): Promise<Array<SoftSkillCategory>> {
    return new Promise((resolve, reject) => {
      if (this.referentiel().length > 0){
        resolve(this.referentiel());
        this.referentiel$.next(this.referentiel())
      } else {
        
      this.http
        .get<Array<SoftSkillCategory>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=core_competency_list_competencies&filters[0][column]=competencyframeworkid&filters[0][value]=3"
        )
        .subscribe((data: Array<SoftSkillCategory>) => {   
          const sk = data.sort((a,b)=>(a.id > b.id) ? 1 : -1);            
          this.referentiel$.next(sk);           
          this.referentielCategories.set(data.filter(sk => sk.parentid === 0).map(sk => sk.id));          
          resolve(data);
        })
      }
    });
  }

  getCoursesWithTag(tag: string) {    
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<any>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=local_plugin_iacdp_get_courses_with_tag&tag=" + tag
        )
        .subscribe((data: Array<any>) => {        
          console.log('courseWithTag:' + tag, data);           
          resolve(data);
      })
    })
  }

  getCompetenciesScale(): Promise<Array<CompetenciesScale>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<CompetenciesScale>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=core_competency_get_scale_values&scaleid=3"
        )
        .subscribe((data: Array<CompetenciesScale>) => {   
          this.competenciesScale$.next(data);     
          resolve(data);
      })
    })
  }

  gradeCompetency(gradeData: {courseid: number, userid: number, competencyid: number, grade: number, note: string} ): Promise<GradeCompetency> {
    return new Promise((resolve, reject) => {
      this.http
        .get<GradeCompetency>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=core_competency_grade_competency_in_course&courseid=" + gradeData.courseid + "&userid=" + gradeData.userid + "&competencyid=" + gradeData.competencyid + "&grade=" + gradeData.grade + "&note=" + gradeData.note
        )
        .subscribe((data: GradeCompetency) => {        
          console.log(data); 
          data.errorcode ? this.setGradeState(false) : this.setGradeState(true);
          resolve(data);
      })
    })
  }

  tutorGradeCompetency(gradeData: {targetid: number, userid: number, competencyid: number, grade: number, note: string, type: string} ): Promise<number> {
    return new Promise((resolve, reject) => {
      this.http
        .get<number>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=local_plugin_iacdp_tutor_grade_competency&targetid=" + gradeData.targetid + "&userid=" + gradeData.userid + "&competencyid=" + gradeData.competencyid + "&grade=" + gradeData.grade + "&note=" + gradeData.note+ "&type=" + gradeData.type
        )
        .subscribe((data: number) => {        
          console.log(data);           
          resolve(data);
      })
    })
  }

  getTutorCompetenciesGrades(userid: number): Promise<Array<CompetenciesGrades>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<CompetenciesGrades>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=local_plugin_iacdp_get_all_tutor_competencies_grades&userid=" + userid
        )
        .subscribe((data: Array<CompetenciesGrades>) => {        
          console.log(data);           
          resolve(data);
      })
    })
  }

  getUserCompetencyGrades(userid: number): Promise<Array<UserCompetencyGrade>> {    
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<UserCompetencyGrade>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=local_plugin_iacdp_get_user_competencies_in_course&courseid=12&userid=" + userid
        )
        .subscribe((data: Array<UserCompetencyGrade>) => {        
          // console.log('userGrades', data);           
          resolve(data);
      })
    })
  }

  getFormationList(): Array<{id:number, name: string}> {
    const list: Array<{id:number, name: string}> = []    
    this.categories().forEach( c => {
      if(c.parent === MoodleCategory.formations){
        const domaineName = c.name;
        this.categories().forEach( c2 => {
          if(c2.parent === c.id){
            const diplomeName =  c2.name;
            this.allCourses().forEach( c3 => {
              if(c3.categoryid === c2.id && !c3.shortname.toLowerCase().includes('questionnaire') && !c3.shortname.toLowerCase().includes('passeport') && c3.visible){
                const cat = {id:-1, name: domaineName + " / " + diplomeName};
                // debugger;
                if(list.find(c => c.id === cat.id && c.name === cat.name) === undefined){
                  list.push(cat);
                }
                list.push({id: c3.id, name: c3.shortname});
              }
            })
          }
        });
      }
    })
    console.log(list);
    return list;
  }

  getAllCourses(): Promise<Array<MoodleCourse>> {
    return new Promise((resolve, reject) => {
      // if(this.allCourses){
      //   resolve(this.allCourses);
      // } else {        
        this.http
          .get<Array<MoodleCourse>>(
            `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
              "&moodlewsrestformat=json&wsfunction=core_course_get_courses"
          )
          .subscribe((data: Array<MoodleCourse>) => {
            try{
              this.allCourses$.next(data);
              this.allCourses$.complete();  
            }
            catch(error) {
              this.allCourses$.error(error);
            }  
            console.log('allCourses', data);          
            resolve(data);
          });
      // }
    });
  }
  
  getUserEnrolledCourses(): Promise<Array<EnrolledCourse>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<EnrolledCourse>>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=core_enrol_get_users_courses&userid=" + this.auth.currentUser().auth.id
        )
        .subscribe((data: Array<EnrolledCourse>) => {  
          data.map((course: EnrolledCourse, index: number) => {
            this.eventsCoursesQuery = this.eventsCoursesQuery + '&events[courseids][' + index + ']=' + course.id;

            if (course.category && !this.categoriesId.includes(course.category)) {
              this.categoriesId.push(course.category);
              this.eventsCategoryQuery = this.eventsCategoryQuery + '&events[categoryids][' + index + ']=' + course.category;
            }

            this.getCourseSk(course.id)
              .then((sk: Array<CompetencyResponse>)=>{              
                if (sk[0]) {                  
                  if (sk[0].competency.path === "/0/") {                
                    course.sktype = sk[0].competency.id;
                  }
                  else{         
                    course.skparentid = sk[0].competency.parentid;           
                    course.sktype = sk[0].competency.path.charAt(4) === "/" ? Number(sk[0].competency.path.substring(3, 4)) : Number(sk[0].competency.path.substring(3, 5))                                        
                  }
                  course.sk = sk[0].competency.id                  
                }
              })
            .catch((error) => console.error(error));
          }); 

          try {
            this.enrolledCourses$.next(data);
            this.enrolledCourses$.complete();
          }
          catch(error) {
            this.enrolledCourses$.error(error);
          }

          console.log('enrolledCourses', data);
          resolve(data);
        });
    });
  }

  getAllUserEnrolledCourses(userId: number): Promise<Array<EnrolledCourse>> {
    return new Promise((resolve, reject) => {     
        this.http
          .get<Array<EnrolledCourse>>(
            `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
              "&moodlewsrestformat=json&wsfunction=local_plugin_iacdp_get_enrolled_courses&userid=" + userId 
          )
          .subscribe((data: Array<EnrolledCourse>) => {
            try{
              this.allEnrolledCourses$.next(data);
              this.allEnrolledCourses$.complete();  
            }
            catch(error) {
              this.allEnrolledCourses$.error(error);
            }  
            // console.log('allEnrolledCourses', data);          
            resolve(data);
          });
      // }
    });
  }

  getUserProgressedCourses() : Promise<Array<EnrolledCourse>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<EnrolledCourse>>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=core_enrol_get_users_courses&userid=" + this.auth.currentUser().auth.id
        )
        .subscribe((data: Array<EnrolledCourse>) => {
          let filteredCourses: Array<EnrolledCourse> = []
          data.map((course: EnrolledCourse) => {            
            if (course.progress !== null) filteredCourses.push(course);

            this.getCourseSk(course.id)
              .then((sk: Array<CompetencyResponse>)=>{
                if (sk[0]) {
                  if (sk[0].competency.path === "/0/") {                
                    course.sktype = sk[0].competency.id;
                  }
                  else{
                    course.sktype = sk[0].competency.path.charAt(4) === "/" ? Number(sk[0].competency.path.substring(3, 4)) : Number(sk[0].competency.path.substring(3, 5))             
                  }
                  course.sk = sk[0].competency.id
                }
              })  
              .catch((error) => console.error(error));         
          }); 

          try{
            this.progressCourses$.next(filteredCourses);
            this.progressCourses$.complete();
          }
          catch(error) {
            this.progressCourses$.error(error);
          }      

          console.log('progressedCourses', filteredCourses);
          resolve(filteredCourses);
        });
    });
  }

  
  async getUserEvents(): Promise<EventResponse> {        
    return new Promise((resolve, reject) => {
      this.http
        .post<EventResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
          "&moodlewsrestformat=json&wsfunction=core_calendar_get_calendar_events" + this.eventsCoursesQuery + "" + this.eventsCategoryQuery + "&options[userevents]=1&options[siteevents]=1",
          ''
        )
        .subscribe((data: EventResponse) => {
          try{
            this.userEvents$.next(data.events);
            this.userEvents$.complete();
          }
          catch(error) {
            this.userEvents$.error(error);
          }
          // console.log("userEvents", data)
          resolve(data);
        });
    });
  }

  getUserInfos(id: number): Promise<Array<User>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<User>>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=core_user_get_users_by_field&field=id&values[0]=" + id
        )
        .subscribe((data: Array<User>) => {    
          console.log("userInfos", data);                    
          resolve(data);
        });
    });
  }

  getCourseUsers(courseId: number): Promise<Array<MoodleUser>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<MoodleUser>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=core_enrol_get_enrolled_users&courseid=" + courseId
        )
        .subscribe((data: Array<MoodleUser>) => {    
          // console.log("allUsers", data);                    
          resolve(data);
        });
    });
  }

  getCourseSk(id: number): Promise<Array<CompetencyResponse>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<CompetencyResponse>>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=core_competency_list_course_competencies&id=" + id
        )
        .subscribe((data: Array<CompetencyResponse>) => {    
          // console.log("courseSk", data);                  
          resolve(data);
        });
    });
  }

  getCourseCategories(): Promise<Array<Category>> {
    return new Promise((resolve, reject) => {
      if(this.categories()){
        resolve(this.categories());
      } else {
        
      this.http
        .get<Array<Category>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=core_course_get_categories"
        )
        .subscribe((data: Array<Category>) => { 
          try{
            this.courseCategories$.next(data);
            this.courseCategories$.complete();  
          }
          catch(error) {
            this.courseCategories$.error(error);
          }
          console.log("courseCategories", data);                  
          resolve(data);
        });
      }
    });
  }

  getUserNotifs(): Promise<NotificationResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<NotificationResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=message_popup_get_popup_notifications&useridto=0&limit=5"
        )
        .subscribe((data: NotificationResponse) => { 
          data.notifications.map((notif: Notification) => {
            this.getUserInfos(notif.useridfrom)
              .then((user: Array<User>) => {                
                if (user.length !== 0) notif.sender = user[0].fullname;
              })
              .catch((error) => console.error(error));
          });

          try{
            this.userNotifs$.next(data.notifications);
            this.userNotifs$.complete();
          }
          catch(error) {
            this.userNotifs$.error(error);
          }    
                  
          // console.log("userNotifs", data);                  
          resolve(data);
        });
    });
  }

  getCourseContent(id: number): Promise<Array<CourseResponse>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<CourseResponse>>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=core_course_get_contents&courseid=" + id
        )
        .subscribe((data: Array<CourseResponse>) => { 
          console.log("courseContent", data);                  
          resolve(data);
        });
    });
  }

  getCoursePagesContent(id: number): Promise<PagesResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<PagesResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_page_get_pages_by_courses&courseids[0]=" + id
        )
        .subscribe((data: PagesResponse) => { 
          // console.log("coursePagesContent", data);                  
          resolve(data);
        });
    });
  }

  getCourseLessonsContent(id: number): Promise<LessonsResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<LessonsResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_lesson_get_lessons_by_courses&courseids[0]=" + id
        )
        .subscribe((data: LessonsResponse) => { 
          // console.log("courseLessonsContent", data);                  
          resolve(data);
        });
    });
  }

  getCoursePageContent(courseid: number): Promise<Array<CompetenciesPassport>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_page_get_pages_by_courses&courseids[0]=" + courseid
        )
        .subscribe((data: any) => { 
          let pagesContent: Array<CompetenciesPassport> = [];
          data.pages.forEach((page: CompetenciesPassport) => {
            let content: CompetenciesPassport = {
              id: page.id,
              name: page.name,
              content: page.content,
              course: page.course,
              coursemodule: page.coursemodule,
              timemodified: page.timemodified
            }
            pagesContent.push(content);     
          });
          this.passport$.next(pagesContent);
          console.log("coursePageContent", pagesContent);                  
          resolve(pagesContent);
        });
    });
  }

  getCourseForums(id: number, resultsArray: Array<ForumResponse>): Promise<Array<ForumResponse>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<ForumResponse>>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_forum_get_forums_by_courses&courseids[0]=" + id
        )
        .subscribe((data: Array<ForumResponse>) => { 
          if (data.length !== 0) {            
            data.map((forum: ForumResponse)=>{
              resultsArray.push(forum);
            }) 
          }

          try{            
            this.forumContent$.next(resultsArray);
            this.forumContent$.complete();
          }
          catch(error) {
            this.forumContent$.error(error);
          } 
          // console.log("courseForums", data);                  
          resolve(data);
        });
    });
  }

  getForumDiscussions(id: number, resultsArray: Array<DiscussionPost>): Promise<DiscussionResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<DiscussionResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_forum_get_forum_discussions&forumid=" + id
        )
        .subscribe((data: DiscussionResponse) => { 
          if (data.discussions.length !== 0) {                
            data.discussions.map((discussion: DiscussionPost)=>{
              discussion.forumid = id;
              resultsArray.push(discussion);
            })
          }

          try{
            this.discussionsContent$.next(resultsArray);
            this.discussionsContent$.complete();
          }
          catch(error) {
            this.discussionsContent$.error(error);
          }           
          // console.log("forumDiscussions", data);                  
          resolve(data);
        });
    });
  }

  getDiscussionPosts(discussion: DiscussionPost, resultsArray: Array<PostResponse>): Promise<PostResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<PostResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_forum_get_discussion_posts&discussionid=" + discussion.discussion
        )
        .subscribe((data: PostResponse) => {                     
          if (data.posts.length !== 0) {                
            data.discussionid = discussion.id;
            resultsArray.push(data);                    
          }  

          try{
            this.postsContent$.next(resultsArray);
            this.postsContent$.complete();
          }
          catch(error) {
            this.postsContent$.error(error);
          }  
          // console.log("discussionPosts", id, data);                  
          resolve(data);
        });
    });
  }

  getAllQuizzes(): Promise<Array<Quiz>> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Array<Quiz>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=local_plugin_iacdp_get_quiz"
        )
        .subscribe((data: Array<Quiz>) => {                           
          const quizArray: Array<Quiz> = [];     
          if(typeof data === 'string'){
            data = JSON.parse(data);
          }           
          data.forEach((quiz: Quiz) => {                                  
            if (quiz.questions.length > 0) {
              quiz.formType = "quiz";            
              quizArray.push(quiz);
            }
          })                  
          try{
            this.allQuiz$.next(quizArray);
            this.allQuiz$.complete();
          }
          catch(error) {
            this.allQuiz$.error(error);
          }  
          console.log('allQuiz', quizArray);
          resolve(quizArray);
        });
    });
  }

  startQuizAttempt(id: number): Promise<StartQuizAttemptResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<StartQuizAttemptResponse>(
          `${this.moodleWebservice}?wstoken=${ this.auth.getToken() }` +
            "&moodlewsrestformat=json&wsfunction=mod_quiz_start_attempt&forcenew=1&quizid=" + id
        )
        .subscribe((data: StartQuizAttemptResponse) => { 
          console.log("startAttempt", data, id);                  
          resolve(data);
        });
    });
  }

  processQuizAttempt(id: number, attemptQuery: string, finishattempt: number): Promise<ProcessQuizAttemptResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get<ProcessQuizAttemptResponse>(
          `${this.moodleWebservice}?wstoken=${ this.auth.getToken() }` +
          "&moodlewsrestformat=json&wsfunction=mod_quiz_process_attempt&attemptid=" + id + attemptQuery + "&finishattempt=" + finishattempt
        )
        .subscribe((data: ProcessQuizAttemptResponse) => { 
          console.log("processAttempt", data);                  
          resolve(data);
        });
    });
  }

  getUserAttempts(quizid: number, userid: number, status: string): Promise<UserQuizAttemptResponse> {    
    return new Promise((resolve, reject) => {
      this.http
      .get<UserQuizAttemptResponse>(
        `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
        "&moodlewsrestformat=json&wsfunction=mod_quiz_get_user_attempts&quizid=" + quizid + "&userid=" + userid + "&status=" + status
      )
      .subscribe((data: UserQuizAttemptResponse) => { 
          // console.log("getUserAttempt", data);                  
          resolve(data);
        });
      });
  }

  getAttemptData(attemptId: number, pageId: number): Promise<QuizAttemptDetailsResponse> {
    return new Promise((resolve, reject) => {
      this.http
      .get<QuizAttemptDetailsResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
          "&moodlewsrestformat=json&wsfunction=mod_quiz_get_attempt_data&attemptid=" + attemptId + "&page=" + pageId
        )
        .subscribe((data: QuizAttemptDetailsResponse) => { 
          console.log("attemptData", data);                  
          resolve(data);
        });
    });
  }
  
  enrolUser(userId: number, courseId: Array<number>): Promise<any> {
    let enrolQuery: string = "";
    courseId.forEach((cid: any, idx: number) => enrolQuery += "&enrolments[" + idx + "][roleid]=5&enrolments[" + idx + "][userid]=" + userId + "&enrolments[" + idx + "][courseid]=" + cid);
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=enrol_manual_enrol_users" + enrolQuery
        )
        .subscribe((data: any) => { 
          console.log(enrolQuery);          
          console.log("enrolUser", data);                  
          resolve(data);
        });
    });
  }

  addDiscussionPosts(id: number, subject: string, message: string): Promise<PostResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .post<PostResponse>(
          `${this.moodleWebservice}?wstoken=${this.auth.getToken()}` +
            "&moodlewsrestformat=json&wsfunction=mod_forum_add_discussion_post&postid=" + id + "&subject=" + subject + "&message=" + message,
            ''
        )
        .subscribe((data: PostResponse) => { 
          // console.log("addPost", data);                  
          resolve(data);
        });
    });
  }

  async getCourseStudents(courseId: number) {
    let allStudents: Array<MoodleUser> = []; 
    
    await this.getCourseUsers(courseId).then((users: Array<MoodleUser>) => {        
      allStudents = users.filter((user: MoodleUser) => {        
        return user.roles ? user.roles.some((role: UserRole) => role.roleid === 5) : null;        
      });

      allStudents.map((student: MoodleUser) => {
        this.getAllUserEnrolledCourses(student.id).then((course: any) => student.enrolledcourses = course);
      })
    });     
    try{
      this.allStudents$.next(allStudents);
      // this.allStudents$.complete();  
    }
    catch(error) {
      this.allStudents$.error(error);
    }  
  }

  async getTeacherDashboard() {
    const students: Array<MoodleUser> = await firstValueFrom(this.allStudents$);
    const studentList : Array<MoodleUser>= structuredClone(students);
    const lastQuizzes: Array<any> = [];
    studentList.map((student: MoodleUser) => {
      if (student.enrolledcourses) {
        student.quizzes = [];      
        for (const course of student.enrolledcourses) {                  
          const quizzes: Array<Quiz> = (this.getCourseQuizzes(course.id, false) || []).map(q => structuredClone(q)); 
          quizzes!.map((quiz: Quiz) => {            
            this.getUserAttempts(quiz.quizzId, student.id, 'all').then((res) => {
              quiz.attempts = res?.attempts ?? null;
            });
          });
          
          student.quizzes.push(quizzes);
        }
      }
    });

    await Promise.all(studentList.map(async (student: any) => {
      student.quizzes = [];
      let studentData: any = {
        studentId: null,
        studentFullname: null,
        attemptId: null,
        quizName: null,
        timeStart: null,
        timeFinish: null,
        state: null
      }
      studentData.studentId = student.id;
      studentData.studentFullname = student.fullname;
      
      for (const course of student.enrolledcourses) {        
        const quizzes = (this.getCourseQuizzes(course.id, false) || []).map(q => structuredClone(q)); 
        
        await Promise.all(quizzes.map(async (quiz: any) => {          
          const res = await this.getUserAttempts(quiz.quizzId, student.id, 'all');
          studentData.quizName = quiz.name;          
          quiz.attempts = res?.attempts ?? null;
          if (res.attempts.length > 0) {
            res.attempts.map((attempt: any) => {
              studentData.attemptId = attempt.id;
              studentData.timeStart = attempt.timestart;
              studentData.timeFinish = attempt.timefinish;
              studentData.state = attempt.state;                
              lastQuizzes.push(studentData);
            })
          }
        }));

        student.quizzes.push(quizzes);
        this.getUserCompetencyGrades(student.id).then((res: any) => {
          student.grades = res;   
        })
      }
    }));

    try{          
      console.log('teacherDashboard', studentList);    
      this.lastQuizzes$.next(lastQuizzes);
      this.lastQuizzes$.complete();          
      this.teacherDashboardData$.next(studentList);
      this.teacherDashboardData$.complete();
    }
    catch(error){
      this.teacherDashboardData$.error(error);
    }
  }

  getSkLevels(id: number): Array<SoftSkillCategory> {
    let skLevels: Array<SoftSkillCategory> = [];
    this.referentiel().forEach(sk => {
      sk.description = sk.description.replace(/<.*?>/g, '');    
      if (sk.parentid === id) skLevels.push(sk);   
    })
    return skLevels;
  }
  
  getSkById(id: number): SoftSkillCategory {
    return this.referentiel().find(sk => sk.id === id)!;
  }
  getSkillsByParent(id: number): Array<SoftSkillCategory> {
    return this.referentiel().filter(sk => sk.parentid === id)!;
  }
  getSkByCategory(array: Array<SoftSkillCategory>, category: number): Array<SoftSkillCategory>  {
    let filteredSk = array.filter((sk) => {        
      return sk.parentid === category;      
    })
    return filteredSk;
  }

  getCourseCategory(id: number): number | undefined {
    let filteredCourse: MoodleCourse | undefined = this.allCourses().find((course: MoodleCourse) => course.id === id);
    if (!filteredCourse) return;
    return filteredCourse.categoryid;
  }

  getSignupQuizzes(categoryId: number): [Array<Quiz>, Array<number>] {
    const quizzes: Array<Quiz> = [];
    const quizzesCourseId: Array<number> = [];
    const categoriesId: Array<number> = [];
    
    this.courseCategories$
      .subscribe((data: Array<Category>) => {
        data.forEach((cat: Category) => {          
          if (cat.id == categoryId) {
            const path = cat.path.split('/');
            path.forEach((id: string) => {              
              categoriesId.push(parseInt(id));       
            })
          }
        })  
      })
      .unsubscribe()
    
    this.allCourses$
      .subscribe((data: Array<MoodleCourse>)=>{        
        data.forEach((course: MoodleCourse) => {                                      
          if (categoriesId.includes(course.categoryid)) { 
            const categoryQuiz: Array<Quiz> | null = this.getCourseQuizzes(course.id, true);
            if (categoryQuiz !== null) {              
              if(categoryQuiz.length === 1) {
                quizzes.push(categoryQuiz[0]);
                if(!quizzesCourseId.includes(categoryQuiz[0].cid)) quizzesCourseId.push(categoryQuiz[0].cid);
              } 
              else{
                categoryQuiz.forEach((quiz: Quiz) => {
                  quizzes.push(quiz);
                  if(!quizzesCourseId.includes(quiz.cid)) quizzesCourseId.push(quiz.cid);
                });
              }
            }               
          }         
        })     
      })
      .unsubscribe()
    return [quizzes, quizzesCourseId];
  }

  async getSignupAutoEvalQuiz(quizzes: Array<Quiz>, courseId: number): Promise<Quiz[]> {
    return quizzes.filter((quiz: Quiz) => quiz.cid === courseId);
  }
  
  getAutoEvalQuiz(): Array<Quiz> {
    const quizzes: Array<Quiz> = [];                       
    this.enrolledCourses$.subscribe((res: any) => {      
      res.map((course: any)=>{        
        if (course.category === 9 && course.id !== 12) {
          const evaluationQuiz: Array<Quiz> | null = this.getCourseQuizzes(course.id, false);
          if (evaluationQuiz !== null) {              
            if(evaluationQuiz.length === 1) {
              quizzes.push(evaluationQuiz[0]);
            } 
            else{
              evaluationQuiz.forEach(quiz => {
                if (quiz.name === "Autoévaluation v2") {
                  quizzes.push(quiz);
                }
              });
            }
          } 
        }
      })
    })
    return quizzes; 
  }

  getCourseQuizzes(courseId: number, isSignup: boolean = false): Array<Quiz> | null {
    const courseQuiz: Array<Quiz> | null = [];
    this.allQuiz$
    .subscribe((data: Array<Quiz>)=>{              
      data.forEach((quiz: Quiz) => {   
        let conditions: boolean = isSignup == true ? quiz.cid === courseId && quiz.isSignupQuiz === 1 && quiz.isVisible === 1 : quiz.cid === courseId;                   
        if (conditions) courseQuiz.push(quiz);     
        })
      })
      .unsubscribe()    
    return courseQuiz;
  }

  getQuestionIndex(attemptUniqueId: number, questionIndex: number): string {
    return "q" + attemptUniqueId + ":" + questionIndex;
  }

  getQuestionName(answerType: string, isSingle: number, attemptUniqueId: number, questionIndex: number, answerIndex: number): string {
    if (answerType === "multichoice" && isSingle === 0) {
      return this.getQuestionIndex(attemptUniqueId, questionIndex) + "_choice" + answerIndex;  
    }
    else{
      return this.getQuestionIndex(attemptUniqueId, questionIndex) + "_answer";  
    }
  }

  setQuizAttemptData(index: number, name: string, value: number | string): string {
    return "&data[" + index + "][name]=" + name + "&data[" + index + "][value]=" + value;
  }

  getUserByEmail(mail: string): Observable<Array<MoodleUserDetail>> {
    return this.http
        .get<Array<MoodleUserDetail>>(
          `${this.moodleWebservice}?wstoken=${environment.moodleAdminToken}` +
            "&moodlewsrestformat=json&wsfunction=core_user_get_users_by_field&field=email&values[0]="+mail
      )
  }

  setItemColor(parentid: number): string {
    if (parentid === this.referentielCategories()[1]) {
      return 'green';
    }
    else if (parentid === this.referentielCategories()[0]) {
      return 'blue';
    }
    else if (parentid === this.referentielCategories()[2]) {
      return 'purple';
    }
    else if (parentid === this.referentielCategories()[3]) {
      return 'yellow';
    }
    else{              
      return 'default';
    }
  }

  public getActiveStudentData(studentId: number) {
    let studentData: any;
    this.teacherDashboardData$.subscribe((res: any) => {
      studentData = res.filter((data: any) => data.id == studentId);
    })    
    return studentData;
  }

  // setCompetencyColor(competencyid: number) { 
  //   let currentCompetency = filteredReferentiel.filter((competency: any) => competency.id === competencyid);        
  //   return 'iacdp-' + this.setItemColor(currentCompetency[0].parentid);
  // }

  public setGradeState(state: boolean) {
    this.gradeState$.next(state);
  }
}